var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[(_vm.type === 'oven250')?_c('span',{staticClass:"oven"},[_vm._v("250 °С")]):_vm._e(),_c('inline-svg',{staticClass:"w-6 h-6",attrs:{"src":_vm.getImage(_vm.type)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }